import { Player } from '@quickplay/player-interface';
import { TritonPlayerBuilder } from '../TiritonPlayerBuilder';
import { PlayerBuilder, createPlayerBuilder } from '@quickplay/player';

export const PlayerFactory = {
  createPlayer(builder: TritonPlayerBuilder, sbmContentUrl?: string): Player {
    const playerBuilder: PlayerBuilder = createPlayerBuilder();
    playerBuilder
      .mediaElement(builder.videoElement)
      .mediaWrapperElement(builder.videoWrapper)
      .mediaUrl(sbmContentUrl ?? builder.contentUrl)
      .mediaType(builder.mediaFormatType)
      .drmLicenseUrl(builder.licenseUrl)
      .drmScheme(builder.drmType)
      .playbackOptions(builder.options)
      .certificate(builder.serverCertificate)
      .logger(builder.configuredLogger)
      .playerLibrary(builder.library)
      .sideCarTracks(builder.getSideLoadedTracks)
      .usePlayer(builder.extPlayer, builder.libInstance);

    if (builder.thumbnailPreviewEndpointUrl) {
      playerBuilder.enableThumbnailPreview(builder.thumbnailPreviewEndpointUrl, builder.config);
    }

    return playerBuilder.build();
  },
};
